/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Modal, Table } from 'htlib-copy';
import { func, string } from 'prop-types';

import { useGetSingleCheck } from 'hooks/checks';
import AsyncUI from 'components/AsyncUI';

import './InfoModal.scss';

export default function InfoModal({ checkId, onClose }) {
  const singleCheckQuery = useGetSingleCheck(checkId, {
    projection: '_id,labeling,check,labeling_no_for_all,check_no_for_all',
  });

  const check = singleCheckQuery.data?.check || {};

  const entityIds = Object.keys(check?.labeling || {}) || [];
  const data = entityIds.map(entityId => {
    const labeled = (check.labeling && check.labeling[entityId]) || '-';
    const moderated = (check.check && check.check[entityId]) || '-';

    return {
      entityId,
      labeled: <span className={labeled}>{labeled}</span>,
      moderated: <span className={moderated}>{moderated}</span>,
    };
  });

  const columns = [
    { head: 'Entity id', dataKey: 'entityId' },
    { head: 'Labeled', dataKey: 'labeled' },
    { head: 'Moderated', dataKey: 'moderated' },
  ];

  return (
    <Modal onClose={onClose}>
      <AsyncUI query={singleCheckQuery}>
        <div className="InfoModal">
          {check && (
            <>
              <h3 className="InfoModal__title">Info on check : {check._id}</h3>
              <p className="">
                <span className="nfa">Labeled &quot;No for all&quot; :</span>
                {check.labeling_no_for_all ? (
                  <span className="yes">Yes</span>
                ) : (
                  <span className="no">No</span>
                )}
              </p>
              <p className="">
                <span className="nfa">Moderated &quot;No for all&quot; :</span>
                {check.check_no_for_all ? (
                  <span className="yes">Yes</span>
                ) : (
                  <span className="no">No</span>
                )}
              </p>
              <Table data={data} columns={columns} />
            </>
          )}
        </div>
      </AsyncUI>
    </Modal>
  );
}

InfoModal.propTypes = {
  checkId: string.isRequired,
  onClose: func.isRequired,
};
